<template>
  <v-dialog v-model="dialog" max-width="320">
    <v-card>
      <v-card-title class="headline">
        {{ isResolved ? 'Deselect resolve?' : 'Resolve multimatch?' }}
      </v-card-title>
      <v-card-text>
        <p class="body-1 mb-0">Name</p>
        <p class="caption">{{ $v(row, 'rhapsody_name') }}</p>
        <p class="body-1 mb-0">Entry name</p>
        <p class="caption mb-0">{{ $v(row, 'entry_variation_name') }}</p>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text color="error" @click="handleClose">Close</v-btn>
        <v-btn text color="success" @click="handleResolve">
          {{ isResolved ? 'Deselect' : 'Resolve' }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
      row: null
    };
  },
  computed: {
    isResolved() {
      return this.$v(this.row, 'migrationPoll.checked', false);
    }
  },
  methods: {
    open(row) {
      this.dialog = true;
      this.row = row;
    },
    handleClose() {
      this.dialog = false;
      this.row = null;
    },
    handleResolve() {
      this.$emit('onResolveMultimatch', this.row);
      this.handleClose();
    }
  }
};
</script>
